module.exports = __webpack_public_path__ + "img/injection.3da39f1b.jpg";